import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import loadTraits from '../collectionForm/traits';
import { colFormRef } from './consts';

export default grapesjs.plugins.add('gjs-add-remove-collection-form', (editor, opts) => {
  let c = opts || {};

  let defaults = {
    pfx: 'add-remove-collection-form',
    blocks: [colFormRef],
    defaultStyle: true,
    labelColForm: 'Add To Collection',
    labelColFormCategory: 'Forms',
    labelTraitMethod: 'Method',
    labelTraitAction: 'Action',
    labelColName: 'Add Collection',
  };

  for (let name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }

  loadComponents(editor, c);
  loadBlocks(editor, c);
  loadTraits(editor, c);
});
